// @ts-nocheck
import * as React from "react";

const Move: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 -960 960 960">
            <path d="M480-113.85 340.77-252.96l26.58-26.19 94.5 94.38v-277.58H184.27l93.88 94.04-26.3 26.31-138.62-138.62 139-139 26.08 26.08-94.16 94.27h277.7v-277.19l-94.39 93.88-26.08-26.19L480-847.38l139.12 139.23-26.08 26.07-94.27-94.38v277.19h276.85l-93.89-93.54 26.42-26.42 138.62 138.61L708.15-342l-26.07-26.08 93.77-94.27H498.77v277.47l94.04-94.5 26.42 26.3L480-113.85Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Move);
